<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'delivery-heat-count-map.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'delivery-heat-count-map.data' | transloco }}</small>
              <hx-date-range-select [maxWeekRange]="1" [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'delivery-heat-count-map.mapType' | transloco }}</small>
              <hx-checkbox [(ngModel)]="params.isHeatMap" label="filter.heatMap" [hideNo]="true" (valueChange)="navigate()"></hx-checkbox>
            </div>
          </div>
          <br><br>
          <hx-loader [length]="response.orderInfos.length" [isLoading]="isLoading"></hx-loader>
          <div id="map" *ngIf="response.orderInfos.length"></div>
        </div>
      </div>
    </div>
  </div>
</div>
